import React, { useState } from "react";
import { Avatar, Box, Link, Typography } from "@mui/material";
import {
  font_13_icon,
  getNewersWorldProfileUrl,
  isValidString,
} from "../../utils/utils";
import ImageModal from "../ImageModal";
import "./userModuleBootcamp.scss";
import IconButtons from "../IconButtons/IconButtons";
import { user_module_bootcamp_icon } from "../../constants/icons";
import UserTableAvatar from "../UserTableAvatar/UserTableAvatar";

// Helper function to get user data from module or bootcamp
const getUserData = (module, bootcamp) => {
  if (module) {
    return {
      imgAlt: module?.fullName,
      imgSrc: module?.profilePictureUrl,
      deleted: module?.deleted,
      label: module?.fullName,
      subLabel: module?.email,
      href: module?.employeeCode,
    };
  }
  return {
    imgAlt: bootcamp?.fullName,
    imgSrc: bootcamp?.profilePictureUrl,
    deleted: bootcamp?.deleted,
    label: bootcamp?.fullName,
    subLabel: bootcamp?.email,
    href: bootcamp?.employeeCode,
  };
};

// Helper function to get bootcamp data
const getBootcampData = (bootcamp) => {
  if (!bootcamp) return null;
  return {
    imgAlt: bootcamp?.fullName,
    imgSrc: bootcamp?.profilePictureUrl,
    deleted: bootcamp?.deleted,
    label: bootcamp?.fullName,
    subLabel: bootcamp?.email,
    href: bootcamp?.employeeCode,
  };
};

// Component for User Cell
const UserCell = ({ userData, handleOpen }) => {
  const { imgAlt, imgSrc, deleted, label, subLabel, href } = userData;
  const profileUrl = deleted ? null : getNewersWorldProfileUrl(href);

  return (
    <Box className="user-cell" sx={{ flexWrap: "nowrap" }}>
      <Avatar
        alt={imgAlt}
        className="user-avatar"
        src={imgSrc || imgAlt}
        onClick={() => handleOpen(imgSrc)}
      />
      <Box className="user-cell-info">
        <Link
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          sx={{
            textDecoration: "none",
            "&:hover": { textDecoration: "none" },
          }}
        >
          <Typography
            variant="font_12"
            sx={{
              color: deleted ? "red" : null,
              wordBreak: "keep-all !important",
            }}
          >
            {label}
          </Typography>
        </Link>
        <Typography
          variant="grayEmail"
          sx={{
            color: deleted ? "red" : null,
            wordBreak: "keep-all !important",
          }}
        >
          {subLabel}
        </Typography>
      </Box>
    </Box>
  );
};

// Component for Bootcamp Icon
const BootcampIcon = ({ bootcampData }) => {
  if (!bootcampData) return null;

  return (
    <IconButtons
      width={font_13_icon}
      height={font_13_icon}
      image={user_module_bootcamp_icon}
      classList="padding-left-half"
      tooltip={
        <UserTableAvatar
          imgAlt={bootcampData.imgAlt}
          imgSrc={bootcampData.imgSrc}
          href={bootcampData.href}
          label={bootcampData.label}
          subLabel={bootcampData.subLabel}
          deleted={bootcampData.deleted}
        />
      }
    />
  );
};

const UserModuleBootcamp = ({ module, bootcamp, moduleId }) => {
  const [imageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const handleOpen = (imgUrl) => {
    if (isValidString(imgUrl)) {
      setImageUrl(imgUrl);
      setImageOpen(true);
    } else {
      handleClose();
    }
  };
  const handleClose = () => {
    setImageUrl(null);
    setImageOpen(false);
  };

  const userData = getUserData(module, bootcamp);
  const bootcampData = getBootcampData(bootcamp);
  const hasData = module || bootcamp;
  const showBootcampIcon = module && moduleId;

  if (!hasData) {
    return (
      <>
        <Typography variant="font_12">-</Typography>
        <ImageModal
          open={imageOpen}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      </>
    );
  }

  return (
    <>
      <Box className="boot-module-cell" sx={{ flexWrap: "nowrap" }}>
        <UserCell userData={userData} handleOpen={handleOpen} />
        {showBootcampIcon && <BootcampIcon bootcampData={bootcampData} />}
      </Box>
      <ImageModal
        open={imageOpen}
        handleClose={handleClose}
        imageUrl={imageUrl}
      />
    </>
  );
};

export default UserModuleBootcamp;
